import React from "react";
import itLabsLogo from '../assets/Images/Sponzors/itLabs-01.png';
import copyKendy from '../assets/Images/Sponzors/Copy of kendy-logo-png-transparent (1).png';
import deliciaLogo from '../assets/Images/Sponzors/Delicia logo.jpg';
import healthyFood from '../assets/Images/Sponzors/Healthy Food Nod.png';
import meltyLogo from '../assets/Images/Sponzors/Melty logo.jpg';
import vitalia from '../assets/Images/Sponzors/Vitalia-1.png';
import jsLogo from '../assets/Images/Sponzors/js_logo1-1.png';
import panPan from '../assets/Images/Sponzors/pan-pan-bakery-skopje.jpg';
import vegera from '../assets/Images/Sponzors/Вегера лого.jpg';
import kvatro from '../assets/Images/Sponzors/Кватро.jpeg';

export default function Partners() {
  const mainPartner = {
    name: "itLabs",
    logo: itLabsLogo,
    link: "https://www.it-labs.com/",
    description: "",
  };

  const partners = [
    { name: "Kendy", logo: copyKendy, link: "https://www.kendy.mk/" },
    { name: "Delicia", logo: deliciaLogo, link: "https://delicia.mk/" },
    { name: "Healthy Food Nod", logo: healthyFood, link: "https://www.instagram.com/nod.pb?utm_medium=copy_link" },
    { name: "Melty", logo: meltyLogo, link: "https://www.instagram.com/melty.mk/" },
    { name: "Vitalia", logo: vitalia, link: "https://www.vitalia.com.mk/en/home/" },
    { name: "JS Aktuel", logo: jsLogo, link: "https://aktuel.com.mk/" },
    { name: "Pan Pan Bakery", logo: panPan, link: "https://www.panpan.mk/" },
    { name: "Вегера", logo: vegera, link: "https://www.facebook.com/vegera.pekarnica/?locale=mk_MK" },
    { name: "Кватро", logo: kvatro, link: "" },
  ];

  return (
    <div className="w-full min-h-screen bg-[#e4570b] pt-6 pb-12">

      <section
        className="
          bg-[#6a310a]
          mx-4 sm:mx-10 lg:mx-24
          rounded-2xl
          shadow-2xl
          py-16 sm:py-20 lg:py-28
          flex flex-col items-center text-center
          mb-16
        "
      >
        <div className="mb-8">
          <div className="inline-block bg-white/10 backdrop-blur-sm rounded-full px-6 py-2 mb-6">
            <span className="text-white/90 text-xl  font-medium tracking-wide">Главен партнер</span>
          </div>
        </div>

        <img
          src={mainPartner.logo}
          alt={mainPartner.name}
          className="w-64 sm:w-80 lg:w-96 xl:w-[450px] h-auto mb-10 drop-shadow-2xl"
        />

        <h1 className="text-4xl sm:text-5xl lg:text-6xl xl:text-7xl font-bold mb-6 text-white">
          {mainPartner.name}
        </h1>

        {mainPartner.description && (
          <p className="max-w-2xl text-gray-200 mb-8 px-4 text-lg sm:text-xl leading-relaxed">
            {mainPartner.description}
          </p>
        )}

        <a
          href={mainPartner.link}
          target="_blank"
          rel="noopener noreferrer"
          className="px-8 py-4 bg-[#749269] text-white rounded-lg text-xl sm:text-2xl font-semibold shadow-lg hover:shadow-xl hover:scale-105 hover:bg-[#85a377] transition-all duration-300"
        >
          Посети Website
        </a>
      </section>

      <section className="py-8 px-4 sm:px-8 lg:px-20">
        <div className="text-center mb-12">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold mb-4 text-white">
            Поддржувачи
          </h2>
          <div className="w-24 h-1 bg-white/40 mx-auto rounded-full"></div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6 lg:gap-8 max-w-7xl mx-auto">
          {partners.map((p, index) => (
            <div
              key={index}
              className="
                bg-[#6a310a]
                text-white
                shadow-xl
                rounded-xl
                p-8
                flex flex-col items-center text-center
                hover:scale-105
                hover:shadow-2xl
                hover:bg-[#7a3f1a]
                transition-all
                duration-300
                border border-white/10
              "
            >
              <div className="w-full h-32 flex items-center justify-center mb-5">
                <img
                  src={p.logo}
                  alt={p.name}
                  className="max-w-full max-h-full object-contain"
                />
              </div>

              <h3 className="text-xl font-semibold mb-4 min-h-[3rem] flex items-center">
                {p.name}
              </h3>

              {p.link ? (
                <a
                  href={p.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="mt-auto px-5 py-2.5 bg-[#749269] text-white rounded-lg shadow-md hover:shadow-lg hover:scale-105 hover:bg-[#85a377] transition-all duration-300 font-medium"
                >
                  Дознај повеќе
                </a>
              ) : (
                <span className="mt-auto px-5 py-2.5 bg-gray-600/50 text-white/60 rounded-lg font-medium cursor-not-allowed">
                  Дознај повеќе
                </span>
              )}
            </div>
          ))}
        </div>
      </section>

      {/* Media Partners Section */}
      <section className="py-16 px-4 sm:px-8 lg:px-20">
        <div className="text-center mb-12">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold mb-4 text-white">
            Медиумски партнери
          </h2>
          <div className="w-24 h-1 bg-white/40 mx-auto rounded-full"></div>
        </div>

        <div className="max-w-5xl mx-auto">
          <div
            className="
              bg-[#6a310a]
              rounded-2xl
              shadow-2xl
              overflow-hidden
              border border-white/10
            "
          >
            {/* MRT Partner Header */}
            <div className="p-8 sm:p-10 text-center border-b border-white/10">
              <div className="inline-block bg-white/10 backdrop-blur-sm rounded-full px-6 py-2 mb-6">
                <span className="text-white/90 text-lg font-medium tracking-wide">Официјален медиумски партнер</span>
              </div>
              
              <h3 className="text-3xl sm:text-4xl font-bold text-white mb-4">
                МРТ - Македонска Радио Телевизија
              </h3>
              
              <a
                href="https://www.mrt.com.mk/"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 px-6 py-3 bg-[#749269] text-white rounded-lg text-lg font-semibold shadow-lg hover:shadow-xl hover:scale-105 hover:bg-[#85a377] transition-all duration-300"
              >
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                  <path d="M11 3a1 1 0 100 2h2.586l-6.293 6.293a1 1 0 101.414 1.414L15 6.414V9a1 1 0 102 0V4a1 1 0 00-1-1h-5z" />
                  <path d="M5 5a2 2 0 00-2 2v8a2 2 0 002 2h8a2 2 0 002-2v-3a1 1 0 10-2 0v3H5V7h3a1 1 0 000-2H5z" />
                </svg>
                Посети ја веб страницата
              </a>
            </div>

            {/* YouTube Video Embed */}
            <div className="p-6 sm:p-10">
              <div className="mb-6 text-center">
                <p className="text-white/80 text-lg">
                  Погледнете го нашето претставување на МРТ
                </p>
              </div>
              
              <div className="relative w-full aspect-video rounded-xl overflow-hidden shadow-2xl ring-4 ring-white/10">
                <iframe
                  src="https://www.youtube.com/embed/8kxBFtLg1T8?rel=0&modestbranding=1"
                  title="Futurathon на МРТ"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  allowFullScreen
                  className="absolute top-0 left-0 w-full h-full"
                  loading="lazy"
                ></iframe>
              </div>

              <div className="mt-6 text-center">
                <a
                  href="https://youtu.be/8kxBFtLg1T8?si=PrD8vVymr5phpELJ"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 text-white/70 hover:text-white transition-colors duration-300"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
                  </svg>
                  Гледај на YouTube
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Other Media Partners */}
        <div className="mt-12 max-w-5xl mx-auto">
          <div className="text-center mb-8">
            <div className="inline-block bg-white/10 backdrop-blur-sm rounded-full px-6 py-2">
              <span className="text-white/90 text-lg font-medium tracking-wide">Останати медиумски партнери</span>
            </div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {[
              { name: "Emiter", link: "https://emiter.com.mk/", description: "Технолошки портал" },
              { name: "IT.mk", link: "https://it.mk/", description: "ИТ вести и информации" },
              { name: "Smart Portal", link: "https://smartportal.mk/", description: "Дигитални иновации" },
              { name: "Konektify", link: "https://www.konektify.net/", description: "Поврзување и мрежа" },
            ].map((partner, index) => (
              <a
                key={index}
                href={partner.link}
                target="_blank"
                rel="noopener noreferrer"
                className="
                  group
                  bg-[#6a310a]
                  rounded-xl
                  p-6
                  text-center
                  border border-white/10
                  shadow-lg
                  hover:shadow-2xl
                  hover:scale-105
                  hover:bg-[#7a3f1a]
                  transition-all
                  duration-300
                  flex flex-col items-center justify-center
                "
              >
                <div className="w-12 h-12 mb-4 bg-white/10 rounded-full flex items-center justify-center group-hover:bg-[#749269] transition-colors duration-300">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                    <path strokeLinecap="round" strokeLinejoin="round" d="M21 12a9 9 0 01-9 9m9-9a9 9 0 00-9-9m9 9H3m9 9a9 9 0 01-9-9m9 9c1.657 0 3-4.03 3-9s-1.343-9-3-9m0 18c-1.657 0-3-4.03-3-9s1.343-9 3-9m-9 9a9 9 0 019-9" />
                  </svg>
                </div>
                
                <h4 className="text-xl font-bold text-white mb-2 group-hover:text-[#85a377] transition-colors duration-300">
                  {partner.name}
                </h4>
                
                <p className="text-white/60 text-sm mb-3">
                  {partner.description}
                </p>

                <span className="inline-flex items-center gap-1 text-white/50 text-sm group-hover:text-white/80 transition-colors duration-300">
                  Посети
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" viewBox="0 0 20 20" fill="currentColor">
                    <path fillRule="evenodd" d="M10.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L12.586 11H5a1 1 0 110-2h7.586l-2.293-2.293a1 1 0 010-1.414z" clipRule="evenodd" />
                  </svg>
                </span>
              </a>
            ))}
          </div>
        </div>
      </section>

    </div>
  );
}
